import clsx from 'clsx'
import React from 'react'
import { InfoCircle } from 'iconsax-react'
import Tooltip from '../Tooltip'
import useStyles from './styles'
import { useTheme } from '@mui/material'

type InfoProps = React.HTMLAttributes<HTMLDivElement> & {
  text?: string | React.ReactElement
  className?: string
  size?: number
}

const Info: React.FC<InfoProps> = ({
  text,
  className,
  size,
  style = {},
  ...props
}) => {
  const theme = useTheme()

  const classes = useStyles()

  if (!text) {
    return null
  }

  return (
    <Tooltip title={text} arrow>
      <div
        className={clsx(classes.root, className)}
        style={{ ...style }}
        {...props}
      >
        <InfoCircle className='information' size={size ?? theme.size.lg} />
        <InfoCircle
          className='information-fill'
          size={size ?? theme.size.lg}
          variant='Bold'
        />
      </div>
    </Tooltip>
  )
}

export default Info
